module.exports = __webpack_public_path__ + "img/fairies under the hot sun.6f39e465.png";